<template>

    <div>
        <nav class="px-8 pt-2 mb-8 border-bottom border-teal texte-center">
            <div class="flex nav" id="tabs">
                <a class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8 active"
                    href="#general" aria-controls="general" role="tab" data-toggle="tab" @click="callTabs('general')">
                    General
                </a>
                <a v-if="!isPm" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                    href="#master-client" aria-controls="master-client" role="tab" data-toggle="tab" @click="callTabs('master')">
                    Master Company
                </a>
                <a v-if="!isPm" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                    href="#sales-status" aria-controls="sales-status" role="tab" data-toggle="tab" @click="callTabs('sale')">
                    {{ getFieldLabel(fieldLabels, 'sales-status')}}
                </a>
                <a v-if="!isPm" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                    href="#products-services" aria-controls="products-services" role="tab" data-toggle="tab" @click="callTabs('products')">
                    {{ getFieldLabel(fieldLabels, 'products-and-services')}}
                </a>
                <a v-if="!isPm" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                    href="#client-profile" aria-controls="client-profile" role="tab" data-toggle="tab" @click="callTabs('client')">
                    {{ getFieldLabel(fieldLabels, 'client-profile')}}
                 </a>
                <a v-if="!isPm" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                    href="#contract-type" aria-controls="contract-type" role="tab" data-toggle="tab" @click="callTabs('contract')">
                    {{ getFieldLabel(fieldLabels, 'contract-type')}}

                </a>
                <a v-if="!isPm" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                    href="#foundation" aria-controls="foundation" role="tab" data-toggle="tab" @click="callTabs('foundation')">
                    Foundation
                </a>
                <a v-if="!isPm && this.team.CE_api_key" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                   href="#computerEase" aria-controls="computerEase" role="tab" data-toggle="tab" @click="callTabs('computerEase')">
                    ComputerEase
                </a>
             <a v-if="!isPm" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                 href="#quotes" aria-controls="quotes" role="tab" data-toggle="tab" @click="callTabs('quotes')">
                  Quotes
              </a>
                <a v-if="!isPm && this.team.has_qrvey_access" class="hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                   href="#customReports" aria-controls="customReports" role="tab" data-toggle="tab" @click="callTabs('customReports')">
                    Custom Reports
                </a>
            </div>
        </nav>

        <div class="w-full" v-if="!isPm">
            <report-filter
                v-if="(selectedReportId != 'company-export' && selectedReportId != 'company-contact-export') && currentTabName != 'customReports'"
                class="mb-4 -mt-3"
                :tabName="currentTabName"
                :date-range="dateRange"
                :user="user"
                :users="users"
                :project-stages="projectStages"
                :office="office"
                :contract-type="contractType"
                :fixed-date-range-identifier="fixedDateRangeIdentifier"
                @updated-filter="(newFilter) => filterUri = newFilter"
                :is-pm="isPm"
                :masks="masks"
                :user-ids="userIds"
                :user-role="userRole"
                :field-labels="fieldLabels"
                >
            </report-filter>

            <div class="tab-content flex">
                <div role="tabcard" class="tab-pane w-5/6 active" id="general">
                    <general-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :is-pm="isPm"
                        :user-role="userRole"
                        :team="team"

                    >
                    </general-report>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane w-5/6" id="master-client">
                    <master-client-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                        :directDownloadReportTeamIds="directDownloadReportTeamIds">
                    </master-client-report>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane w-5/6" id="sales-status">
                    <sales-status-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                        :field-labels="fieldLabels"
                    >
                    </sales-status-report>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane w-5/6" id="products-services">
                    <products-services-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                        :field-labels="fieldLabels"
                    >
                    </products-services-report>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane w-5/6" id="client-profile">
                    <client-profile-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                        :field-labels="fieldLabels"
                    >
                    </client-profile-report>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane w-5/6" id="contract-type">
                    <contract-type-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                        :field-labels="fieldLabels"
                    >
                    </contract-type-report>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane w-5/6" id="foundation">
                    <foundation-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                    >
                    </foundation-report>
                </div>
                <div v-if="!isPm && this.team.CE_api_key" role="tabcard" class="tab-pane w-5/6" id="computerEase">
                    <computerEase-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                        :field-labels="fieldLabels"
                    >
                    </computerEase-report>
                </div>
                <div v-if="!isPm" role="tabcard" class="tab-pane w-5/6" id="quotes">
                   <quotes-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :is-pm="isPm"
                        :user-role="userRole"
                        :team="team"
                        :max-quote-amount="maxQuoteAmount"
                        :min-quote-amount="minQuoteAmount"
                        :active-users="activeUsers"
                    >
                    </quotes-report>
                </div>
                <div v-if="!isPm && this.team.has_qrvey_access" role="tabcard" class="tab-pane w-100" id="customReports">
                    <custom-reports
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :user-role="userRole"
                        :team="team"
                        :user="user"
                    >
                    </custom-reports>
<!--                    <div ref="qrveyContainer">-->
<!--                        &lt;!&ndash; This container will be directly manipulated in the mounted hook &ndash;&gt;-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <div class="w-full" v-if="isPm">
            <report-filter-pm
                v-if="selectedReportId != 'company-export'"
                class="mb-4 -mt-3"
                :tabName="currentTabName"
                :date-range="dateRange"
                :user="user"
                :users="users"
                :project-stages="projectStages"
                :office="office"
                :contract-type="contractType"
                :fixed-date-range-identifier="fixedDateRangeIdentifier"
                @updated-filter="(newFilter) => filterUri = newFilter"
                :is-pm="isPm"
                :masks="masks"
                :field-labels="fieldLabels"
            >
            </report-filter-pm>

            <div class="tab-content flex">
                <div role="tabcard" class="tab-pane active w-5/6" id="general">
                    <general-report
                        @change-report="(val) => selectedReportId = val"
                        :filter-uri="filterUri"
                        :is-pm="isPm"
                        :team="team"
                    >
                    </general-report>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomReports from "./custom-reports.vue";

export default {
    name: 'reports-tabs',
    components: {CustomReports},

    props: ['date-range', 'user', 'users', 'office', 'contract-type', 'fixed-date-range-identifier', 'is-pm', 'project-stages', 'masks','user-ids','userRole', 'team','fieldLabels', 'directDownloadReportTeamIds', 'maxQuoteAmount', 'minQuoteAmount','activeUsers'],

    data() {
        return {
            filterUri: '',
            selectedReportId: null,
            currentTabName: 'general',
            config: {
                domain: "https://gxwvn.qrveyapp.com",
                qv_token: ""
            }
        }
    },
    mounted() {
    },
    computed: {
    },
    methods:{
        callTabs(tab){
            this.currentTabName = tab;
        },
        // initQrvey() {
        //     this.$nextTick(() => {
        //         const config = {
        //             api_key: "Fz09i7eNMAbluwbt43Te4ADzwxl2EylOGH5EwTjs",
        //             domain: "https://gxwvn.qrveyapp.com",
        //             user_id: "8gxyFjkHM",
        //             app_id: "LXAb_td_L"
        //         };
        //         const qrveyWidget = document.createElement('qrvey-end-user');
        //         qrveyWidget.setAttribute('settings', JSON.stringify(config));
        //         this.$refs.qrveyContainer.appendChild(qrveyWidget);
        //     });
        // },
        // getJWT() {
        //     const GENERATE_URL = `${this.config.domain}/devapi/v4/core/login/token`;
        //     const GENERATE_BODY = {
        //         version: "2",
        //         userid: "_LsOacRrY",
        //         appid: "yCcIStYhN",
        //         dashboard_id: "Ah3rmuJDVcwjlWlxpiJNB",
        //         fit_panel_button: true,
        //         clientid: this.user.uuid,
        //         permissions: [
        //             {
        //                 // "dataset_id": "ud2cm1y9e",
        //                 "record_permissions": [
        //                     {
        //                         "security_name": "team_security_column",
        //                         "validation_type": "EQUAL",
        //                         "values": [`${this.user.current_team_id}`]
        //                     }
        //                 ]
        //             }
        //         ],
        //         personalization: {
        //             enabled: true,
        //         },
        //     };
        //     console.log(GENERATE_BODY);
        //     const GENERATE_CONFIG = {
        //         headers: {
        //             'x-api-key': "Fz09i7eNMAbluwbt43Te4ADzwxl2EylOGH5EwTjs",
        //             'Content-Type': 'application/json'
        //         }
        //     };
        //     return axios
        //         .post(GENERATE_URL, GENERATE_BODY, GENERATE_CONFIG)
        //         .then(response => response.data.token)
        //         .catch(error => console.log('generateToken ->', error));
        // },
        // init() {
        //     this.getJWT()
        //         .then(res => {
        //             console.log("res", res)
        //             this.config.qv_token = res;
        //             this.setToken();
        //         });
        // },
        // setToken() {
        //     setTimeout(_ => {
        //         let dashboardBuilder = document.createElement('qrvey-builders');
        //         // let dashboardView = document.createElement('qrvey-end-user');
        //         dashboardBuilder.settings = this.config;
        //         // dashboardView.settings = this.config;
        //         document.body.append(dashboardBuilder);
        //         // document.body.append(dashboardView);
        //     }, 500);
        // }

    }
}
</script>
